import { Link } from 'react-router-dom';

const services = [
  {
    title: 'Sanierung & Renovierung',
    description:
      'Vollständige Gebäudesanierung, energetische Modernisierung und Komplettrenovierung – wir bringen Ihre Immobilie auf den neuesten Stand.',
    icon: 'ri-hammer-line',
    image:
      'https://public.readdy.ai/ai/img_res/809bf565f7e047471dd6310c2c8f4528.jpg',
    link: '/leistungen#sanierung',
  },
  {
    title: 'Trockenbau',
    description:
      'Präziser Innenausbau mit Gipskarton, Systemdecken und Trennwänden – schnell, sauber und nach Maß für Wohn- und Gewerberäume.',
    icon: 'ri-layout-3-line',
    image:
      'https://readdy.ai/api/search-image?query=professional%20drywall%20installation%20trockenbau%20interior%20construction%20worker%20installing%20gypsum%20board%20panels%20modern%20room%20bright%20clean%20space%20precise%20work%20germany%20simple%20background&width=600&height=400&seq=bau-trockenbau-001&orientation=landscape',
    link: '/leistungen#trockenbau',
  },
  {
    title: 'Fassade & Außenwände',
    description:
      'Fassadensanierung, WDVS-Systeme und Außenputz für ein ansprechendes Erscheinungsbild und optimale Wärmedämmung Ihrer Immobilie.',
    icon: 'ri-home-2-line',
    image:
      'https://readdy.ai/api/search-image?query=professional%20facade%20renovation%20fassade%20building%20exterior%20worker%20applying%20insulation%20thermal%20plaster%20modern%20residential%20building%20clean%20finish%20germany%20simple%20background%20daylight&width=600&height=400&seq=bau-fassade-001&orientation=landscape',
    link: '/leistungen#fassade',
  },
  {
    title: 'Bodenbeläge',
    description:
      'Fachgerechte Verlegung von Fliesen, Parkett, Laminat und Estrich – für ein perfektes Ergebnis auf jedem Untergrund.',
    icon: 'ri-grid-line',
    image:
      'https://readdy.ai/api/search-image?query=professional%20flooring%20installation%20tile%20laying%20parquet%20wood%20floor%20worker%20precise%20craftsmanship%20modern%20interior%20bright%20clean%20room%20germany%20bodenbelag%20simple%20background&width=600&height=400&seq=bau-boden-001&orientation=landscape',
    link: '/leistungen#bodenbelaege',
  },
  {
    title: 'Malerarbeiten',
    description:
      'Innen- und Außenanstriche, Tapezierarbeiten und dekorative Gestaltung – saubere Ausführung, deckende Qualität und sorgfältige Vorbereitung.',
    icon: 'ri-paint-brush-line',
    image:
      'https://readdy.ai/api/search-image?query=professional%20interior%20painting%20maler%20worker%20applying%20white%20paint%20roller%20brush%20clean%20modern%20room%20bright%20freshly%20painted%20walls%20germany%20residential%20simple%20neutral%20background&width=600&height=400&seq=bau-maler-001&orientation=landscape',
    link: '/leistungen#malerarbeiten',
  },
  {
    title: 'Garten- & Landschaftsbau',
    description:
      'Von Pflasterarbeiten, Teichbau und Beetgestaltung über Rasenpflege und Bepflanzung bis hin zu Terrassenbau und Entwässerungslösungen – wir gestalten Ihren Außenbereich nachhaltig und individuell.',
    icon: 'ri-plant-line',
    image:
      'https://readdy.ai/api/search-image?query=professional%20garden%20landscape%20construction%20galabau%20worker%20laying%20natural%20stone%20pavement%20pathway%20lush%20green%20plants%20shrubs%20modern%20residential%20garden%20outdoor%20design%20germany%20bright%20daylight%20simple%20elegant%20background&width=600&height=400&seq=bau-galabau-001&orientation=landscape',
    link: '/leistungen#galabau',
  },
  {
    title: 'Bauzeichnungen für Garten & Landschaften',
    description:
      'Maßgenaue Planungs- und Bauzeichnungen für Garten- und Landschaftsprojekte – von der ersten Skizze bis zum vollständigen Ausführungsplan.',
    icon: 'ri-draft-line',
    image:
      'https://readdy.ai/api/search-image?query=professional%20landscape%20architecture%20drawing%20blueprint%20garden%20planning%20design%20drafting%20table%20technical%20drawing%20pencil%20compass%20ruler%20detailed%20plan%20outdoor%20green%20space%20germany%20clean%20bright%20studio%20simple%20background&width=600&height=400&seq=bau-zeichnung-001&orientation=landscape',
    link: '/leistungen#bauzeichnungen',
  },
];

export default function ServicesSection() {
  return (
    <section className="py-12 sm:py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="text-center mb-10 sm:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 sm:mb-4">
            Unsere Leistungen
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-600 max-w-3xl mx-auto px-4">
            Von der Sanierung bis zur Gartengestaltung – wir bieten das komplette Spektrum an
            Bau-, Sanierungs- und GalaBau-Dienstleistungen für Privat und Gewerbe
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {services.map((service) => (
            <div
              key={service.title}
              className="group bg-white rounded-xl overflow-hidden hover:shadow-xl transition-all duration-300 cursor-pointer border border-gray-100"
            >
              <div className="relative h-48 sm:h-64 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                <div className="absolute bottom-3 left-3 sm:bottom-4 sm:left-4">
                  <div className="w-12 h-12 sm:w-14 sm:h-14 bg-[#0D2B4E] rounded-lg flex items-center justify-center">
                    <i className={`${service.icon} text-xl sm:text-2xl text-white`} />
                  </div>
                </div>
              </div>
              <div className="p-4 sm:p-6">
                <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2 sm:mb-3">
                  {service.title}
                </h3>
                <p className="text-gray-600 mb-3 sm:mb-4 text-sm leading-relaxed">
                  {service.description}
                </p>
                <Link
                  to={service.link}
                  className="inline-flex items-center gap-2 text-[#0D2B4E] font-semibold hover:gap-3 transition-all cursor-pointer"
                >
                  <span>Mehr erfahren</span>
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line" />
                  </div>
                </Link>
              </div>
            </div>
          ))}
        </div>

        {/* Hinweis: Reinigung & Hausmeisterservice */}
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-between gap-4 border border-gray-100 rounded-xl px-6 py-5 bg-[#F8F7F4]">
          <div className="flex items-center gap-4">
            <div className="w-10 h-10 flex items-center justify-center bg-[#0D2B4E] rounded-lg flex-shrink-0">
              <i className="ri-sparkling-2-line text-[#C8A96E] text-lg" />
            </div>
            <div>
              <p className="font-semibold text-gray-900 text-sm">Gebäudereinigung & Hausmeisterservice</p>
              <p className="text-gray-500 text-xs mt-0.5">Diese Leistungen finden Sie auf unserer Facility-Service-Website.</p>
            </div>
          </div>
          <a
            href="https://www.igmfacilityservice.de"
            target="_blank"
            rel="noopener noreferrer"
            className="flex-shrink-0 inline-flex items-center gap-2 bg-[#0D2B4E] text-white text-sm font-semibold px-5 py-2.5 rounded-lg hover:bg-[#0a2240] transition-colors whitespace-nowrap cursor-pointer"
          >
            igmfacilityservice.de
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-external-link-line" />
            </div>
          </a>
        </div>

      </div>
    </section>
  );
}
